// extracted by mini-css-extract-plugin
export default {"productCarousel":"p0-z"};